import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environment/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

export type ActivateMemberPayload = {
  payment_token: string;
  provider_id: number | null;
  promo_code: string;
};

export type MemberPaymentMethodPayload = {
  payment_token: string;
};

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  protected baseUrl = environment.apiBase
  protected http = inject(HttpClient)  

  getAllMembers = () => this.http.get(`${this.baseUrl}/members`).pipe()

  getMembersByProviderId = (provider_id: number) =>
  this.http.get(`${this.baseUrl}/providers/${provider_id}/members`).pipe();

  getMember = () => this.http.get(`${this.baseUrl}/member`).pipe()

  getMemberById = (member_id: number) => this.http.get(`${this.baseUrl}/member/${member_id}`).pipe()

  submitMember = (member_id: number, dto: ActivateMemberPayload) =>this.http.post(`${this.baseUrl}/members/${member_id}/activate`, dto).pipe()
  
  updateMember = (member_id: number, dto = {}) => 
    this.http.put(`${this.baseUrl}/member/${member_id}`, dto).pipe()

  addDependent = (member_id: number, dto = {}) => 
    this.http.post(`${this.baseUrl}/members/${member_id}/dependents`, dto).pipe()

  editDependent = (member_id: number, dependent_id: number, dto = {}) =>
    this.http.put(`${this.baseUrl}/members/${member_id}/dependents/${dependent_id}`, dto)

  deleteDependent = (member_id: number, id: number) =>
    this.http.delete(`${this.baseUrl}/members/${member_id}/dependents/${id}`).pipe()

  getMembershipNumber = (member_id: number) => 
    this.http.get(`${this.baseUrl}/members/${member_id}/membership-card`)

  submitMemberPayment = (member_id: number, dto: any) => 
    this.http.post(`${this.baseUrl}/members/${member_id}/payment`, dto).pipe()

  getMemberPaymentMethod = (member_id: number) =>
    this.http.get(`${this.baseUrl}/members/${member_id}/payment-method`).pipe()

  addMemberPaymentMethod = (member_id: number, dto: MemberPaymentMethodPayload) =>
    this.http.post(`${this.baseUrl}/members/${member_id}/payment-method`, dto).pipe()

  updateMemberPaymentMethod = (member_id: number, dto: MemberPaymentMethodPayload) =>
    this.http.put(`${this.baseUrl}/members/${member_id}/payment-method`, dto).pipe()

  deleteMemberPaymentMethod = (member_id: number) =>
    this.http.delete(`${this.baseUrl}/members/${member_id}/payment-method`).pipe()

  validatePromoCode = (code: string) => {
    let params = new HttpParams();

    if(code) {
      params = params.set('code', code)
    }
    return this.http.get(`${this.baseUrl}/utility/promo-codes/validate`, {params}).pipe()
  }
}
